const stickyHeader = document.querySelector('[data-behaviour="sticky-header"]');

if(stickyHeader) {

    const observer = new IntersectionObserver( 
        ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
        { threshold: [1] }
    );
    observer.observe(stickyHeader);

}

const menuToggle = document.querySelector('[data-behaviour="menu-toggle"]');

if(menuToggle) {

    menuToggle.addEventListener('click', (e) => {

        e.preventDefault();
        e.stopImmediatePropagation();
        // if it's not this menu open, close the other one
        if (
            document.body.classList.contains('site-menu-open')
        ) {
            menuToggle.classList.remove('is-active');
            document.body.classList.remove('site-menu-open');
        } else {
            document.body.classList.add('site-menu-open');
            menuToggle.classList.add('is-active');
        }

    });
   
}